var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconexample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.70586 18.3063L4.19336 16.7938L9.48711 11.5001L4.19336 6.20635L5.70586 4.69385L10.9996 9.9876L16.2934 4.69385L17.8059 6.20635L12.5121 11.5001L17.8059 16.7938L16.2934 18.3063L10.9996 13.0126L5.70586 18.3063Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconexample);
export default __webpack_public_path__ + "static/media/Icon example.5df9121747172d936f88abfc6701f21b.svg";
export { ForwardRef as ReactComponent };